import { DesignMatchRow } from './types'

export const DESIGN_MATCHES_LOAD = 'DESIGN_MATCHES_LOAD'
export const designMatchesLoad = (
  accountId: string,
  projectId: string,
  page: number,
  loadedItems: DesignMatchRow[],
  productGroupNames: string[] = [],
  supplierNames: string[] = []
) => ({
  type: DESIGN_MATCHES_LOAD,
  accountId,
  projectId,
  page,
  loadedItems,
  productGroupNames,
  supplierNames
})

export const DESIGN_MATCHES_LOAD_SUCCESS = 'DESIGN_MATCHES_LOAD_SUCCESS'
export const designMatchesLoadSuccess = (
  items: DesignMatchRow[],
  totalCount: number,
  hasNextPage: boolean
) => ({
  type: DESIGN_MATCHES_LOAD_SUCCESS,
  items,
  totalCount,
  hasNextPage
})

export const DESIGN_MATCHES_LOAD_FAILURE = 'DESIGN_MATCHES_LOAD_FAILURE'
export const designMatchesLoadFailure = (error: any) => ({
  type: DESIGN_MATCHES_LOAD_FAILURE,
  error
})
